import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";

export default function useOnboarding() {
    const [,setOnboarding] = useLocalStorage('onboarding');
    useEffect(() => {
        setOnboarding(true);
    });
}